import React from 'react';
import { useSelector } from 'react-redux';
import GroupConsultationSettingsContent from '../components/pages/waiting-area/gc-settings/content';

const GroupConsultationSettingsPage = (props) => {
  const showGCSettingsModal = useSelector((state) => state.modalReducer.showGCSettingsModal);
  const isAdmin = useSelector((state) => state.usersReducer.userProfile && state.usersReducer.userProfile.isAdmin);

  return (
    <>
      <div>
        <GroupConsultationSettingsContent
          showGCSettingsModal={showGCSettingsModal}
          waitingArea={props.waitingArea}
          isGCSettingsEnabled={props.isGCSettingsEnabled}
          updateOrView={props.updateOrView}
          isAdmin={isAdmin}
        />
      </div>
    </>
  );
};

export default GroupConsultationSettingsPage;
